import i18n from '../i18n';

export function translate(key: string | undefined, data?: any): any {
    if (!key) {
        return '';
    }
    return i18n.t(key.toLowerCase(), data);
}

export function translateDate(key: string): any {
    return key;
}

export function changeLanguage(language: string) {
    localStorage.setItem('language', language);
    i18n.changeLanguage(language);
}
